<template>
    <div class="form-area col-12 col-lg-auto">
        <!-- Modal to insert/edit a value -->
        <edit-modal
            v-model:is-open="isSampleModalOpen"
            :index="modalSampleIndex"
            :data="modalData"
            @save="handleSave"
        />

        <!-- Table listing all defined values -->
        <collapsible :title="$t('measures.form.list')" :is-open="true">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('measures.form.id') }}</th>
                        <th>{{ $t('measures.form.value') }}</th>
                        <th>{{ $t('measures.form.sampleDate') }}</th>
                        <th>{{ $t('measures.form.arrivalDate') }}</th>
                        <th class="text-right">
                            <button type="button" class="btn dark circle" @click="openSampleModal(null)">
                                <img src="@/assets/pictos/plus.svg" :alt="$t('action.add')" />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(sample, index) in requestData.samples" :key="sample">
                        <td>{{ sample.id }}</td>
                        <td>{{ sample.concentrations[0].value }} {{ $t('unit.ug/l') }}</td>
                        <td>{{ $dateFormat.humanDateTime(sample.date) }}</td>
                        <td>{{ $dateFormat.humanDateTime(sample.date) }}</td>
                        <td class="text-right buttons-container">
                            <button type="button" class="btn link" @click="openSampleModal(index)">
                                <img src="@/assets/pictos/pencil.svg" :alt="$t('action.edit')" />
                            </button>
                            <button type="button" class="btn dark circle" @click="requestData.removeNthSample(index)">
                                <img src="@/assets/pictos/minus.svg" :alt="$t('action.remove')" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </collapsible>
    </div>

    <div class="data-area col-12 col-lg">
        <!-- Modal to edit chart settings -->
        <chart-settings-modal
            :graph-settings-title="$t('chartSettings.groupName.measureSettings')"
            v-model:is-open="isSettingsModalOpen"
            v-model:graph-settings="chartStore.measuresSettings"
        />

        <concentration-chart
            :graph-settings="chartStore.measuresSettings"
            @open-settings="openSettingsModal()"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Collapsible from '@/components/Collapsible.vue';
import EditModal from './EditModal.vue';
import { useRequestDataStore } from '@/store/request-data';
import { DrugSample } from '@/service/models/request/computation/drug-sample';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';

export default defineComponent({
    components: {
        ChartSettingsModal,
        Collapsible,
        ConcentrationChart,
        EditModal,
    },

    setup()
    {
        const requestData = useRequestDataStore();
        const chartStore = useChartsStore();

        const isSampleModalOpen = ref(false);
        const isSettingsModalOpen = ref(false);
        const modalSampleIndex = ref(0);
        const modalData = ref<DrugSample|null>(null);

        function openSampleModal(sampleIndex: number|null): void
        {
            if (sampleIndex === null) {
                modalSampleIndex.value = requestData.samples.length;
                modalData.value = null;
            }
            else {
                modalSampleIndex.value = sampleIndex;
                modalData.value = requestData.samples[sampleIndex];
            }

            isSampleModalOpen.value = true;
        }

        function openSettingsModal(): void
        {
            isSettingsModalOpen.value = true;
        }

        function handleSave(payload: {index: number, data: DrugSample})
        {
            // Save data in the store
            requestData.samples[payload.index] = payload.data;
        }

        return {
            requestData,
            chartStore,
            openSampleModal, isSampleModalOpen, modalSampleIndex, modalData,
            handleSave,
            openSettingsModal, isSettingsModalOpen,
        };
    },
})
</script>
